"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FACET_FILTER_HEADER_TITLE = exports.FACET_FILTER_HEADER = exports.FACET_FILTER_BADGE = exports.ARROW_UP_ICON = exports.ARROW_DOWN_ICON = void 0;
const FACET_FILTER_HEADER = exports.FACET_FILTER_HEADER = 'facet-filter-header';
const ARROW_UP_ICON = exports.ARROW_UP_ICON = 'arrow-up-icon';
const ARROW_DOWN_ICON = exports.ARROW_DOWN_ICON = 'arrow-down-icon';
const FACET_FILTER_HEADER_TITLE = exports.FACET_FILTER_HEADER_TITLE = 'facet-filter-header-title';
const FACET_FILTER_BADGE = exports.FACET_FILTER_BADGE = 'facet-filter-badge';
